import heic2any from "heic2any";

export default {
    props: ['preview', 'index', 'images', 'uuids'],

    data() {
        return {
            uploading: false,
            upload_complete_animation: false,
        }
    },

    computed: {
        image() {
            return this.images[this.index];
        },

        uuid() {
            return this.uuids[this.index]
        }
    },

    methods: {
        removeImage(index) {
            this.$emit('imageRemoved', {
                index: index,
                uuid: this.uuid,
            });
        },

        async uploadImage() {
            this.$emit('imageUploading', true);
            this.uploading = true;

            //this is the image data we will send to the uploads endpoint
            let image_data = {
                file: this.image,
                name: this.image.name,
                uuid: this.uuid,
            };

            if (["image/heic", "image/heif"].includes(image_data.file.type)) {
                const pngFromHeic = await heic2any({ blob: image_data.file, toType: "image/png" });
                image_data.file = new File([pngFromHeic], `${image_data.file.name.substring(0, image_data.name.lastIndexOf("."))}.png`);
                image_data.name = image_data.file.name;
            }

            //store the image
            this.$store.dispatch('storeImage', image_data).then(() => {
                this.uploading = false;
                this.$emit('imageUploaded', this.uuid);
                this.$emit('imageUploading', false);

                this.upload_complete_animation = true;

                setTimeout(() => {
                    this.upload_complete_animation = false;
                }, 700);
            }).catch(() => {
                alert('Error during upload. Either the file type is unsupported or the image size is too big.');

                this.$emit('imageRemoved', {
                    index: this.index,
                    uuid: this.uuid,
                });
            });
        }
    },

    mounted() {
        this.uploadImage();
    }
}